import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './MateriaalBestellingen.css';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const MateriaalBestellingen = () => {
  const navigate = useNavigate();
  const { terms } = useAuth();
  const [bestellingen, setBestellingen] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ status: 'alles', monteur_id: '', zoek: '' });
  const [confirmModal, setConfirmModal] = useState(null);
  const [binnenModal, setBinnenModal] = useState(null);
  const [locatieNeergelegd, setLocatieNeergelegd] = useState('');
  const [showNieuw, setShowNieuw] = useState(false);
  const [nieuw, setNieuw] = useState({ naam: '', aantal: 1, eenheid: 'stuk', object_id: '', object_zoek: '', opmerkingen: '', materiaal_id: '' });
  const [nieuwFiles, setNieuwFiles] = useState([]);
  const [nieuwSaving, setNieuwSaving] = useState(false);
  const [objecten, setObjecten] = useState([]);
  const [catalogus, setCatalogus] = useState([]);
  const [uitVoorraadKeuze, setUitVoorraadKeuze] = useState(true);
  const [fotoModal, setFotoModal] = useState(null);
  const [bestelNr, setBestelNr] = useState('');
  const [scanBusy, setScanBusy] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [scanLocatie, setScanLocatie] = useState('');

  useEffect(() => {
    loadData();
  }, [filter.status, filter.monteur_id]);

  const loadData = async () => {
    try {
      const params = new URLSearchParams();
      if (filter.status !== 'alles') params.append('status', filter.status);
      if (filter.monteur_id) params.append('monteur_id', filter.monteur_id);

      const [bestellingenRes, monteursRes] = await Promise.all([
        api.get('/materialen/bestellingen?' + params.toString()),
        api.get('/gebruikers')
      ]);

      setBestellingen(bestellingenRes.data.bestellingen || []);
      setMonteurs((monteursRes.data.gebruikers || []).filter(g => g.in_planning));
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden:', error);
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.put(`/materialen/bestellingen/${id}`, { status: newStatus, bestelnummer: newStatus === 'besteld' ? (bestelNr || null) : undefined });
      setBestelNr('');
      setConfirmModal(null);
      loadData();
    } catch (error) {
      alert('Fout bij updaten status');
    }
  };

const loadObjecten = async () => {
    if (objecten.length) return;
    try {
      const r = await api.get('/klanten');
      const arr = r.data.klanten || r.data.objecten || (Array.isArray(r.data) ? r.data : []);
      setObjecten(arr);
    } catch (e) { /* stil */ }
  };
  const loadCatalogus = async () => {
    if (catalogus.length) return;
    try { const r = await api.get('/materialen'); setCatalogus(r.data.materialen || []); } catch (e) { /* stil */ }
  };
  const openNieuw = () => {
    setNieuw({ naam: '', aantal: 1, eenheid: 'stuk', object_id: '', object_zoek: '', opmerkingen: '', materiaal_id: '' });
    setNieuwFiles([]); setUitVoorraadKeuze(true); setShowNieuw(true); loadObjecten(); loadCatalogus();
  };
  const uploadFotoBij = async (id, file, type) => {
    const fd = new FormData(); fd.append('foto', file); fd.append('type', type);
    await api.post(`/materialen/bestellingen/${id}/foto`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  };
  const handleNieuwSubmit = async (e) => {
    e.preventDefault();
    if (!nieuw.naam.trim()) { alert('Omschrijving is verplicht'); return; }
    setNieuwSaving(true);
    try {
      const r = await api.post('/materialen/bestellingen/vrij', {
        naam: nieuw.naam, aantal: nieuw.aantal, eenheid: nieuw.eenheid,
        object_id: nieuw.object_id || null, opmerkingen: nieuw.opmerkingen || null,
        materiaal_id: nieuw.materiaal_id || null
      });
      const id = r.data.registratie.id;
      for (const f of nieuwFiles) await uploadFotoBij(id, f, 'aanvraag');
      const gekozen = catalogus.find(m => m.id === nieuw.materiaal_id);
      if (gekozen && uitVoorraadKeuze && Number(gekozen.voorraad) >= Number(nieuw.aantal)) {
        await api.put(`/materialen/bestellingen/${id}/uit-voorraad`);
        setCatalogus(prev => prev.map(m => m.id === gekozen.id ? { ...m, voorraad: Number(m.voorraad) - Number(nieuw.aantal) } : m));
      }
      setShowNieuw(false); loadData();
    } catch (err) { alert('Fout: ' + (err.response?.data?.message || err.message)); }
    finally { setNieuwSaving(false); }
  };
  const handlePakbonFile = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ''; if (!f) return;
    setScanBusy(true);
    try {
      const fd = new FormData(); fd.append('pakbon', f);
      const r = await api.post('/materialen/pakbon/scan', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const regels = (r.data.regels || []).map(rg => {
        const nodig = Number(rg.aantal) || 1; let som = 0; const keuzes = [];
        for (const k of (rg.kandidaten || [])) { if (k.score < 30 || som >= nodig) break; keuzes.push(k.id); som += Number(k.aantal) || 1; }
        return { ...rg, keuzes };
      });
      setScanResult({ ...r.data, regels }); setScanLocatie('');
    } catch (err) { alert('Scan mislukt: ' + (err.response?.data?.message || err.message)); }
    finally { setScanBusy(false); }
  };
  const handlePakbonBevestig = async () => {
    const regels = scanResult.regels.map(r => ({ aantal: Number(r.aantal) || 0, artikelnr: r.artikelnr || null, omschrijving: r.omschrijving || '', eenheid: r.eenheid || null, registratie_ids: r.keuzes || [] }));
    setScanBusy(true);
    try {
      await api.post('/materialen/pakbon/bevestig', { bestand_naam: scanResult.bestand_naam, locatie_neergelegd: scanLocatie || null, uw_referentie: scanResult.extract?.uw_referentie || null, regels });
      setScanResult(null); loadData();
    } catch (err) { alert('Fout: ' + (err.response?.data?.message || err.message)); }
    finally { setScanBusy(false); }
  };
    const handleUitVoorraad = async (b) => {
    if (!window.confirm(`${b.aantal} ${b.eenheid} "${b.materiaal_naam}" uit voorraad pakken (${b.voorraad_locatie || 'locatie onbekend'})?`)) return;
    try { await api.put(`/materialen/bestellingen/${b.id}/uit-voorraad`); loadData(); }
    catch (err) { alert('Fout: ' + (err.response?.data?.message || err.message)); }
  };
  const openFotos = async (b) => {
    try { const r = await api.get(`/materialen/bestellingen/${b.id}/fotos`); setFotoModal({ b, fotos: r.data.fotos || [] }); }
    catch (err) { alert("Fout bij ophalen foto's"); }
  };
  const verwijderFoto = async (fotoId) => {
    if (!window.confirm('Foto verwijderen?')) return;
    try { await api.delete(`/materialen/bestellingen/foto/${fotoId}`); setFotoModal(m => ({ ...m, fotos: m.fotos.filter(f => f.id !== fotoId) })); loadData(); }
    catch (err) { alert('Fout bij verwijderen'); }
  };
  const handleBinnengekomen = async (id) => {
    try {
      await api.put(`/materialen/bestellingen/${id}/binnengekomen`, { locatie_neergelegd: locatieNeergelegd });
      setBinnenModal(null);
      setLocatieNeergelegd('');
      loadData();
    } catch (err) {
      alert('Fout: ' + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze registratie wilt verwijderen?')) return;
    try {
      const r = await api.delete(`/materialen/bestellingen/${id}`);
      if (r.data?.teruggeboekt) alert(r.data.message);
      loadData();
    } catch (error) {
      alert('Fout bij verwijderen');
    }
  };

  const filteredBestellingen = bestellingen.filter(b => {
    if (filter.zoek) {
      const zoekLower = filter.zoek.toLowerCase();
      return b.materiaal_naam?.toLowerCase().includes(zoekLower) ||
             b.referentie?.toLowerCase().includes(zoekLower) ||
             b.artikelnummer?.toLowerCase().includes(zoekLower) ||
             b.monteur_naam?.toLowerCase().includes(zoekLower) ||
             b.klant_naam?.toLowerCase().includes(zoekLower);
    }
    return true;
  });

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  if (loading) return <div className="loading">Laden...</div>;

  return (
    <div className="materiaal-bestellingen">
      <div className="page-header">
        <h1>📦 Materiaal Bestellingen</h1>
        <p>{filteredBestellingen.length} registraties</p>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <label className="btn-besteld" style={{ cursor: scanBusy ? 'wait' : 'pointer', background: '#1d4ed8' }}>
            {scanBusy ? '⏳ Scannen…' : '📄 Pakbon scannen'}
            <input type="file" accept="image/*,application/pdf" capture="environment" style={{ display: 'none' }} onChange={handlePakbonFile} disabled={scanBusy} />
          </label>
          <button className="btn-besteld" style={{ background: '#374151' }} onClick={() => navigate('/voorraad')}>🚐 Voorraad</button>
          <button className="btn-besteld" onClick={openNieuw}>+ Bestelling</button>
        </div>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="🔍 Zoeken..."
          value={filter.zoek}
          onChange={(e) => setFilter({...filter, zoek: e.target.value})}
          className="search-input"
        />
        <select value={filter.status} onChange={(e) => setFilter({...filter, status: e.target.value})}>
          <option value="alles">Alle statussen</option>
          <option value="te_bestellen">Te bestellen</option>
          <option value="besteld">Besteld</option>
          <option value="uit_voorraad">Uit voorraad</option>
        </select>
        <select value={filter.monteur_id} onChange={(e) => setFilter({...filter, monteur_id: e.target.value})}>
          <option value="">Alle monteurs</option>
          {monteurs.map(m => (
            <option key={m.id} value={m.id}>{m.voornaam} {m.achternaam}</option>
          ))}
        </select>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Ref</th>
              <th>Artikelnr</th>
              <th>Materiaal</th>
              <th>Aantal</th>
              <th>Monteur</th>
              <th>{terms?.klant_singular || "Klant"}</th>
              <th>Verzonden</th>
              <th>Status</th>
              <th>Besteld op</th>
              <th>Binnengekomen</th>
              <th>Neergelegd</th>
              <th>Actie</th>
            </tr>
          </thead>
          <tbody>
            {filteredBestellingen.map(b => (
              <tr key={b.id} className={b.status === 'besteld' ? 'besteld' : ''}>
                 <td><code style={{ fontSize: 11 }}>{b.referentie || '-'}</code></td>
                <td><code>{b.artikelnummer || '-'}</code></td>
                <td><strong>{b.materiaal_naam}</strong>{String(b.opmerkingen || '').startsWith('Auto:') && <span title={b.opmerkingen} style={{ marginLeft: 6, fontSize: 11, background: '#ede9fe', color: '#5b21b6', borderRadius: 10, padding: '1px 7px' }}>🤖 auto</span>}{Number(b.aantal_fotos) > 0 && <button onClick={(e) => { e.stopPropagation(); openFotos(b); }} title="Foto's bekijken" style={{ marginLeft: 6, border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 13 }}>📎{b.aantal_fotos}</button>}{!b.binnengekomen_op && Number(b.voorraad) > 0 && (
                  <div style={{ marginTop: 4, fontSize: 12, color: '#065f46', background: '#d1fae5', borderRadius: 6, padding: '3px 8px', display: 'inline-flex', gap: 8, alignItems: 'center' }}>
                    📦 {Number(b.voorraad)} op voorraad{b.voorraad_locatie ? ` · ${b.voorraad_locatie}` : ''}
                    {Number(b.voorraad) >= Number(b.aantal) && <button onClick={(e) => { e.stopPropagation(); handleUitVoorraad(b); }} style={{ border: 'none', background: '#059669', color: 'white', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 12 }}>Uit voorraad</button>}
                  </div>
                )}</td>
                <td>{b.aantal} {b.eenheid}</td>
                <td>{b.monteur_naam || '-'}</td>
                <td>{b.klant_naam || '-'}</td>
                <td>{formatDate(b.verzonden_op)}</td>
                <td>
                  <span className={`status-badge ${b.status}`}>
                    {b.status === 'te_bestellen' ? '🟡 Te bestellen' : b.status === 'uit_voorraad' ? '📦 Uit voorraad' : '✅ Besteld'}
                  </span>
                </td>
                <td>{formatDate(b.besteld_op)}{b.bestelnummer && <div><code style={{ fontSize: 11 }}>{b.bestelnummer}</code></div>}</td>
                <td>{b.binnengekomen_op ? formatDate(b.binnengekomen_op) : (b.status === 'besteld' ? <button className="btn-besteld" onClick={(e) => { e.stopPropagation(); setBinnenModal(b); setLocatieNeergelegd(''); }}>📦 Binnengekomen</button> : '-')}</td>
                <td>{b.locatie_neergelegd || '-'}</td>
                <td>
                  {b.status === 'te_bestellen' && (
                    <button
                      className="btn-besteld"
                      onClick={() => setConfirmModal(b)}
                    >
                      ✓ Markeer besteld
                    </button>
                  )}
                  <button
                    className="btn-verwijder"
                    onClick={() => handleDelete(b.id)}
                  >
                    🗑️ Verwijder
                  </button>
                </td>
              </tr>
            ))}
            {filteredBestellingen.length === 0 && (
              <tr>
                <td colSpan="12" className="empty-state">Geen bestellingen gevonden</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {binnenModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ position: "relative" }} onClick={e => e.stopPropagation()}>
            <h3>📦 Materiaal binnengekomen</h3>
            <button onClick={() => setBinnenModal(null)} style={{ position: "absolute", top: 12, right: 14, background: "transparent", border: "none", fontSize: 24, lineHeight: 1, cursor: "pointer", color: "#94a3b8" }} title="Sluiten">×</button>
            <p><strong>{binnenModal.materiaal_naam}</strong> ({binnenModal.aantal} {binnenModal.eenheid})</p>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Waar is het neergelegd?</label>
              <input type="text" value={locatieNeergelegd} onChange={e => setLocatieNeergelegd(e.target.value)} placeholder="Bijv. Magazijn rek 3, Bus monteur, Kantoor..." style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }} />
            </div>
            <div className="modal-buttons">
              <button onClick={() => setBinnenModal(null)}>Annuleren</button>
              <button className="primary" onClick={() => handleBinnengekomen(binnenModal.id)}>Bevestigen</button>
            </div>
          </div>
        </div>
      )}
      {showNieuw && (
        <div className="modal-overlay" onClick={() => setShowNieuw(false)}>
          <div className="modal-content" style={{ position: 'relative', maxWidth: 640, width: '95vw' }} onClick={e => e.stopPropagation()}>
            <h3>➕ Nieuwe bestelling (niet in catalogus)</h3>
            <button onClick={() => setShowNieuw(false)} style={{ position: 'absolute', top: 12, right: 14, background: 'transparent', border: 'none', fontSize: 24, lineHeight: 1, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            <form onSubmit={handleNieuwSubmit}>
              <div className="form-group">
                <label>Omschrijving *</label>
                <input value={nieuw.naam} onChange={e => setNieuw({ ...nieuw, naam: e.target.value, materiaal_id: '' })} placeholder="Typ om te zoeken in de catalogus, of vul iets nieuws in" required autoFocus autoComplete="off" />
                {nieuw.naam.length >= 2 && !nieuw.materiaal_id && (() => {
                  const q = nieuw.naam.toLowerCase();
                  const hits = catalogus.filter(m => m.actief !== false && ((m.naam || '').toLowerCase().includes(q) || (m.code || '').toLowerCase().includes(q))).slice(0, 12);
                  return hits.length > 0 ? (
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, maxHeight: 200, overflowY: 'auto', marginTop: 4, background: 'white' }}>
                      {hits.map(m => (
                        <div key={m.id} onClick={() => setNieuw({ ...nieuw, naam: m.naam, materiaal_id: m.id, eenheid: m.eenheid || nieuw.eenheid })} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                          <span><code style={{ fontSize: 11, color: '#64748b' }}>{m.code || '—'}</code> {m.naam}</span>
                          <span style={{ color: '#94a3b8', whiteSpace: 'nowrap' }}>{Number(m.voorraad) > 0 && <b style={{ color: '#059669', marginRight: 8 }}>📦 {Number(m.voorraad)}</b>}{m.verkoopprijs != null ? '€ ' + Number(m.verkoopprijs).toFixed(2) : ''} / {m.eenheid}</span>
                        </div>
                      ))}
                    </div>
                  ) : <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 4 }}>Niet in catalogus — wordt als nieuw artikel besteld</div>;
                })()}
                {nieuw.materiaal_id && <div style={{ fontSize: 12, color: '#059669', marginTop: 4 }}>✓ uit catalogus</div>}
                {(() => {
                  const g = catalogus.find(m => m.id === nieuw.materiaal_id);
                  if (!g || Number(g.voorraad) <= 0) return null;
                  const genoeg = Number(g.voorraad) >= Number(nieuw.aantal || 1);
                  return (
                    <div style={{ marginTop: 8, padding: 10, borderRadius: 8, background: '#ecfdf5', border: '1px solid #a7f3d0', fontSize: 13 }}>
                      <div style={{ fontWeight: 600, color: '#065f46' }}>📦 {Number(g.voorraad)} {g.eenheid} op voorraad{g.voorraad_locatie ? ` · ${g.voorraad_locatie}` : ''}</div>
                      <label style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6, cursor: 'pointer' }}>
                        <input type="radio" checked={uitVoorraadKeuze && genoeg} disabled={!genoeg} onChange={() => setUitVoorraadKeuze(true)} /> Uit voorraad pakken (geen bestelling){!genoeg && <span style={{ color: '#b45309' }}> — te weinig voor {nieuw.aantal}</span>}
                      </label>
                      <label style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, cursor: 'pointer' }}>
                        <input type="radio" checked={!uitVoorraadKeuze || !genoeg} onChange={() => setUitVoorraadKeuze(false)} /> Toch bestellen
                      </label>
                    </div>
                  );
                })()}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label>Aantal</label>
                  <input type="number" min="1" step="1" inputMode="decimal" value={nieuw.aantal} onChange={e => setNieuw({ ...nieuw, aantal: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Eenheid</label>
                  <select value={nieuw.eenheid} onChange={e => setNieuw({ ...nieuw, eenheid: e.target.value })}>
                    {['stuk','meter','rol','doos','liter','kg','set'].map(u => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>{terms?.klant_singular || 'Object'} (optioneel — voor kosten per object)</label>
                <input value={nieuw.object_zoek} onChange={e => setNieuw({ ...nieuw, object_zoek: e.target.value, object_id: '' })} placeholder="Zoek op naam, bijv. W0492" />
                {nieuw.object_zoek.length >= 2 && !nieuw.object_id && (
                  <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, maxHeight: 160, overflowY: 'auto', marginTop: 4 }}>
                    {objecten.filter(o => (o.naam || '').toLowerCase().includes(nieuw.object_zoek.toLowerCase())).slice(0, 25).map(o => (
                      <div key={o.id} onClick={() => setNieuw({ ...nieuw, object_id: o.id, object_zoek: o.naam })} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f1f5f9' }}>{o.naam}{o.adres ? <span style={{ color: '#94a3b8' }}> — {o.adres}</span> : null}</div>
                    ))}
                  </div>
                )}
                {nieuw.object_id && <div style={{ fontSize: 12, color: '#059669', marginTop: 4 }}>✓ gekoppeld aan {nieuw.object_zoek}</div>}
              </div>
              <div className="form-group">
                <label>Opmerking</label>
                <textarea rows="3" value={nieuw.opmerkingen} onChange={e => setNieuw({ ...nieuw, opmerkingen: e.target.value })} placeholder="Leverancier, urgentie, waar het voor is…" />
              </div>
              <div className="form-group">
                <label>Foto's (typeplaatje, kapot onderdeel…)</label>
                <input type="file" accept="image/*" multiple onChange={e => setNieuwFiles(Array.from(e.target.files || []))} />
                {nieuwFiles.length > 0 && <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{nieuwFiles.length} bestand(en) geselecteerd</div>}
              </div>
              <div className="modal-buttons">
                <button type="button" onClick={() => setShowNieuw(false)} disabled={nieuwSaving}>Annuleren</button>
                <button type="submit" className="primary" disabled={nieuwSaving}>{nieuwSaving ? 'Opslaan…' : ((() => { const g = catalogus.find(m => m.id === nieuw.materiaal_id); return g && uitVoorraadKeuze && Number(g.voorraad) >= Number(nieuw.aantal || 1) ? '📦 Uit voorraad pakken' : 'Bestelling aanmaken'; })())}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {fotoModal && (
        <div className="modal-overlay" onClick={() => setFotoModal(null)}>
          <div className="modal-content" style={{ position: 'relative', maxWidth: 760, width: '95vw' }} onClick={e => e.stopPropagation()}>
            <h3>📎 {fotoModal.b.materiaal_naam} <span style={{ fontSize: 12, color: '#94a3b8' }}>{fotoModal.b.referentie}</span></h3>
            <button onClick={() => setFotoModal(null)} style={{ position: 'absolute', top: 12, right: 14, background: 'transparent', border: 'none', fontSize: 24, lineHeight: 1, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            {fotoModal.fotos.length === 0 ? <p style={{ color: '#94a3b8' }}>Geen foto's.</p> : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
                {fotoModal.fotos.map(f => (
                  <div key={f.id} style={{ position: 'relative' }}>
                    <a href={f.url} target="_blank" rel="noreferrer"><img src={f.url} alt="" style={{ width: '100%', height: 140, objectFit: 'cover', borderRadius: 6, border: '1px solid #e5e7eb' }} /></a>
                    <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>{f.type === 'pakbon' ? '📄 pakbon' : '📷 aanvraag'} · {formatDate(f.created_at)}</div>
                    <button onClick={() => verwijderFoto(f.id)} style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(0,0,0,.6)', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11, padding: '2px 6px' }}>✕</button>
                  </div>
                ))}
              </div>
            )}
            <div className="form-group" style={{ marginTop: 12 }}>
              <label>Foto toevoegen</label>
              <input type="file" accept="image/*" onChange={async e => { const f = e.target.files?.[0]; if (!f) return; try { await uploadFotoBij(fotoModal.b.id, f, fotoModal.b.status === 'besteld' || fotoModal.b.binnengekomen_op ? 'pakbon' : 'aanvraag'); openFotos(fotoModal.b); loadData(); } catch (err) { alert('Fout bij uploaden'); } e.target.value = ''; }} />
            </div>
          </div>
        </div>
      )}
      {scanResult && (
        <div className="modal-overlay" onClick={() => setScanResult(null)}>
          <div className="modal-content" style={{ position: 'relative', maxWidth: 900, width: '95vw' }} onClick={e => e.stopPropagation()}>
            <h3>📄 Pakbon — {scanResult.extract?.leverancier || 'onbekende leverancier'}</h3>
            <button onClick={() => setScanResult(null)} style={{ position: 'absolute', top: 12, right: 14, background: 'transparent', border: 'none', fontSize: 24, lineHeight: 1, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
              Ordernr: <b>{scanResult.extract?.ordernummer || '—'}</b> · Leverdatum: <b>{scanResult.extract?.leverdatum || '—'}</b>
              <span style={{ marginLeft: 12 }}>Uw referentie (SAP): <input className="refEdit" value={scanResult.extract?.uw_referentie || ''} onChange={e => setScanResult(sr => ({ ...sr, extract: { ...(sr.extract || {}), uw_referentie: e.target.value } }))} style={{ width: 170, padding: '2px 6px', fontFamily: 'monospace' }} placeholder="45…" /></span>
            </div>
            {scanResult.regels.length === 0 && <p style={{ color: '#94a3b8' }}>Geen regels herkend.</p>}
            {scanResult.regels.map((rg, i) => {
              const nodig = Number(rg.aantal) || 1;
              const alle = [...rg.kandidaten, ...(scanResult.open || []).filter(o => !rg.kandidaten.some(k => k.id === o.id)).map(o => ({ ...o, score: 0, why: [] }))];
              const gedekt = alle.filter(k => rg.keuzes.includes(k.id)).reduce((n, k) => n + (Number(k.aantal) || 1), 0);
              const toggle = (id) => setScanResult(sr => ({ ...sr, regels: sr.regels.map((x, j) => j === i ? { ...x, keuzes: x.keuzes.includes(id) ? x.keuzes.filter(y => y !== id) : [...x.keuzes, id] } : x) }));
              const kleur = gedekt === 0 ? '#fff7ed' : gedekt < nodig ? '#fefce8' : gedekt === nodig ? '#f0fdf4' : '#fef2f2';
              return (
                <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, marginBottom: 8, background: kleur }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{rg.aantal} {rg.eenheid || ''} — {rg.omschrijving} {rg.artikelnr && <code style={{ fontSize: 11, color: '#64748b' }}>{rg.artikelnr}</code>}</div>
                    <div style={{ fontSize: 12, whiteSpace: 'nowrap', color: gedekt === nodig ? '#059669' : gedekt > nodig ? '#dc2626' : '#b45309' }}>gekoppeld {gedekt} / geleverd {nodig}</div>
                  </div>
                  <div style={{ maxHeight: 180, overflowY: 'auto', marginTop: 6, border: '1px solid #e5e7eb', borderRadius: 6, background: 'white' }}>
                    {alle.slice(0, rg.keuzes.length + 12).map(k => (
                      <label key={k.id} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 8px', fontSize: 13, borderBottom: '1px solid #f1f5f9', cursor: 'pointer', background: rg.keuzes.includes(k.id) ? '#ecfdf5' : 'transparent' }}>
                        <input type="checkbox" checked={rg.keuzes.includes(k.id)} onChange={() => toggle(k.id)} />
                        <code style={{ fontSize: 11, color: '#64748b' }}>{k.referentie}</code>
                        <span style={{ flex: 1 }}>{k.materiaal_naam} <span style={{ color: '#94a3b8' }}>({k.aantal} {k.eenheid})</span></span>
                        {k.score > 0 && <span style={{ fontSize: 11, color: '#059669' }}>★ {k.why.join(', ') || 'zwak'} [{k.score}]</span>}
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}
            {scanResult.regels.some(r => (Number(r.aantal) || 0) > [...r.kandidaten, ...(scanResult.open || [])].filter(k => r.keuzes.includes(k.id)).reduce((n, k) => n + (Number(k.aantal) || 1), 0)) && (
              <div style={{ fontSize: 12, color: '#1e40af', background: '#dbeafe', borderRadius: 6, padding: '6px 10px', marginTop: 6 }}>ℹ️ Meer geleverd dan gekoppeld — het overschot wordt als voorraad bijgeschreven op de locatie hieronder.</div>
            )}
            <div className="form-group" style={{ marginTop: 10 }}>
              <label>Neergelegd (locatie, ook voor voorraad-overschot)</label>
              <input value={scanLocatie} onChange={e => setScanLocatie(e.target.value)} placeholder="bijv. mag vak 1-b" />
            </div>
            <div className="modal-buttons">
              <button onClick={() => setScanResult(null)} disabled={scanBusy}>Annuleren</button>
              <button className="primary" onClick={handlePakbonBevestig} disabled={scanBusy}>{scanBusy ? 'Verwerken…' : `✓ ${scanResult.regels.reduce((n, r) => n + (r.keuzes || []).length, 0)} bestelling(en) binnengekomen`}</button>
            </div>
          </div>
        </div>
      )}
      {confirmModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ position: "relative" }} onClick={e => e.stopPropagation()}>
            <h3>Materiaal besteld?</h3>
            <button onClick={() => setConfirmModal(null)} style={{ position: "absolute", top: 12, right: 14, background: "transparent", border: "none", fontSize: 24, lineHeight: 1, cursor: "pointer", color: "#94a3b8" }} title="Sluiten">×</button>
            <p>Wil je <strong>{confirmModal.materiaal_naam}</strong> ({confirmModal.aantal} {confirmModal.eenheid}) markeren als besteld?</p>
            <div className="form-group">
              <label>Bestelnummer (SAP 45…, komt op de pakbon als "Uw referentie")</label>
              <input value={bestelNr} onChange={e => setBestelNr(e.target.value)} placeholder="bijv. 4502099185" autoFocus />
            </div>
            <div className="modal-buttons">
              <button onClick={() => { setConfirmModal(null); setBestelNr(''); }}>Annuleren</button>
              <button className="primary" onClick={() => handleStatusChange(confirmModal.id, 'besteld')}>Ja, Besteld</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MateriaalBestellingen;
